export const documentType = {

    ON_CHANGE_UPLOAD_FILE_PROGRESS: "ON_CHANGE_UPLOAD_FILE_PROGRESS",
    ON_CHANGE_PK_CODE_ARRAY: "ON_CHANGE_PK_CODE_ARRAY",
    ON_CHANGE_RELOAD: "ON_CHANGE_RELOAD",

    POST_DOCUMENT_ATTACH_REQUEST: "POST_DOCUMENT_ATTACH_REQUEST",
    POST_DOCUMENT_ATTACH_SUCCESS: "POST_DOCUMENT_ATTACH_SUCCESS",
    POST_DOCUMENT_ATTACH_ERROR: "POST_DOCUMENT_ATTACH_ERROR"
}